import React from "react";
import { GoBack } from "../../../components/Layout/GoBack";
// import { useNavigate } from "react-router-dom"; // If using router

const AboutPlatform = () => {
  return (
    <div className="w-[1024px] mx-auto bg-[#f8faff] min-h-screen relative font-sans text-slate-900 pb-32 shadow-[0_0_50px_rgba(0,0,0,0.05)] overflow-hidden">
      {/* --- Background Faint Map --- */}
      <div
        className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-no-repeat bg-right-top mix-blend-multiply pointer-events-none"
        style={{
          backgroundImage: "url('/img/new/background/chart.jpeg')",
          backgroundSize: "contain",
        }}
      ></div>

      {/* --- Top Bar --- */}
      <GoBack />

      <div className="px-12 relative z-10 flex flex-col gap-8">
        {/* --- Hero Section --- */}
        <div className="flex items-center justify-between mb-2">
          <div className="w-[55%] pr-8">
            <h1 className="text-[3.5rem] font-bold text-[#071330] leading-tight mb-4">
              About the Platform
            </h1>

            <div className="mb-6">
              <h2 className="text-[22px] font-medium text-[#1a4bdf] leading-snug">
                Empowering Africa Through
                <br />
                Smart Investments
              </h2>
              <div className="w-12 h-[3px] bg-[#1a4bdf] mt-4"></div>
            </div>

            <p className="text-lg text-slate-500 leading-relaxed font-medium">
              A trusted digital platform that provides Africans with access to
              smarter financial opportunities and long term wealth growth.
            </p>
          </div>

          <div className="w-[45%] flex justify-end">
            {/* 3D Graphic Placeholder */}
            {/* <img
              src="/img/new/background/about-hero.png"
              alt="Shield and Growth Chart"
              className="w-[380px] object-contain"
            /> */}
          </div>
        </div>

        {/* --- Our Mission Card --- */}
        <div className="bg-white rounded-[2rem] p-10 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100 flex items-center">
          {/* Left: Mission Text */}
          <div className="flex-1 pr-10">
            <div className="flex items-center gap-4 mb-6">
              <div className="text-[#1a4bdf]">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="6"></circle>
                  <circle cx="12" cy="12" r="2"></circle>
                  <path d="M12 2v2"></path>
                  <path d="M12 20v2"></path>
                  <path d="M22 12h-2"></path>
                  <path d="M4 12H2"></path>
                </svg>
              </div>
              <div>
                <h3 className="text-[22px] font-bold text-[#071330]">
                  Our Mission
                </h3>
                <div className="w-8 h-[3px] bg-[#1a4bdf] mt-2"></div>
              </div>
            </div>
            <p className="text-[15px] text-slate-500 font-medium leading-relaxed">
              To empower Africans financially by creating a trusted digital
              environment where people can invest, grow their capital, and build
              sustainable financial futures.
            </p>
          </div>

          {/* Divider */}
          <div className="w-px h-32 bg-gray-100 shrink-0"></div>

          {/* Right: Mission Pillars */}
          <div className="flex-1 pl-10 flex flex-col gap-6">
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-[#f0f4ff] flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <polyline points="9 12 11 14 15 10"></polyline>
                </svg>
              </div>
              <span className="text-[15px] font-medium text-slate-600">
                Financial Growth
              </span>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-[#f0f4ff] flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5c-2.2 0-4 1.8-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <span className="text-[15px] font-medium text-slate-600">
                Stronger Communities
              </span>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-[#f0f4ff] flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
              </div>
              <span className="text-[15px] font-medium text-slate-600">
                Generational Wealth
              </span>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-[#f0f4ff] flex items-center justify-center text-[#1a4bdf] shrink-0">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
              </div>
              <span className="text-[15px] font-medium text-slate-600">
                Global Digital Economy
              </span>
            </div>
          </div>
        </div>

        {/* --- How the Platform Works --- */}
        <div className="bg-white rounded-[2rem] p-10 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100 flex flex-col items-center">
          <h3 className="text-[22px] font-bold text-[#071330] mb-10">
            How the Platform Works
          </h3>

          <div className="flex items-center justify-between w-full relative">
            {/* Step 1 */}
            <div className="flex flex-col items-center text-center w-36 relative z-10">
              <div className="w-16 h-16 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-4 relative shadow-sm border border-blue-50">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                  <polyline points="2 17 12 22 22 17"></polyline>
                  <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
                <div className="absolute -bottom-2 w-6 h-6 bg-[#1a4bdf] text-white text-[11px] font-bold rounded-full flex items-center justify-center border-2 border-white">
                  1
                </div>
              </div>
              <p className="text-[13px] text-slate-500 font-medium leading-snug">
                Choose an
                <br />
                investment plan
              </p>
            </div>

            <div className="flex-1 h-px border-t-2 border-dashed border-gray-200 -mt-10 mx-2"></div>

            {/* Step 2 */}
            <div className="flex flex-col items-center text-center w-36 relative z-10">
              <div className="w-16 h-16 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-4 relative shadow-sm border border-blue-50">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
                  <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
                  <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
                </svg>
                <div className="absolute -bottom-2 w-6 h-6 bg-[#1a4bdf] text-white text-[11px] font-bold rounded-full flex items-center justify-center border-2 border-white">
                  2
                </div>
              </div>
              <p className="text-[13px] text-slate-500 font-medium leading-snug">
                Invest
                <br />
                securely
              </p>
            </div>

            <div className="flex-1 h-px border-t-2 border-dashed border-gray-200 -mt-10 mx-2"></div>

            {/* Step 3 */}
            <div className="flex flex-col items-center text-center w-36 relative z-10">
              <div className="w-16 h-16 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-4 relative shadow-sm border border-blue-50">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
                <div className="absolute -bottom-2 w-6 h-6 bg-[#1a4bdf] text-white text-[11px] font-bold rounded-full flex items-center justify-center border-2 border-white">
                  3
                </div>
              </div>
              <p className="text-[13px] text-slate-500 font-medium leading-snug">
                Monitor growth
                <br />
                in real time
              </p>
            </div>

            <div className="flex-1 h-px border-t-2 border-dashed border-gray-200 -mt-10 mx-2"></div>

            {/* Step 4 */}
            <div className="flex flex-col items-center text-center w-36 relative z-10">
              <div className="w-16 h-16 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-4 relative shadow-sm border border-blue-50">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <polyline points="9 12 11 14 15 10"></polyline>
                </svg>
                <div className="absolute -bottom-2 w-6 h-6 bg-[#1a4bdf] text-white text-[11px] font-bold rounded-full flex items-center justify-center border-2 border-white">
                  4
                </div>
              </div>
              <p className="text-[13px] text-slate-500 font-medium leading-snug">
                Enjoy structured
                <br />
                profit cycles
              </p>
            </div>

            <div className="flex-1 h-px border-t-2 border-dashed border-gray-200 -mt-10 mx-2"></div>

            {/* Step 5 */}
            <div className="flex flex-col items-center text-center w-36 relative z-10">
              <div className="w-16 h-16 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] mb-4 relative shadow-sm border border-blue-50">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="6" width="20" height="12" rx="2"></rect>
                  <circle cx="12" cy="12" r="2"></circle>
                  <path d="M6 12h.01M18 12h.01"></path>
                </svg>
                <div className="absolute -bottom-2 w-6 h-6 bg-[#1a4bdf] text-white text-[11px] font-bold rounded-full flex items-center justify-center border-2 border-white">
                  5
                </div>
              </div>
              <p className="text-[13px] text-slate-500 font-medium leading-snug">
                Withdraw
                <br />
                with ease
              </p>
            </div>
          </div>
        </div>

        {/* --- Why Invest With Us --- */}
        <div className="bg-white rounded-[2rem] p-10 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-100 flex flex-col items-center">
          <h3 className="text-[22px] font-bold text-[#071330] mb-10">
            Why Invest With Us?
          </h3>

          <div className="w-full grid grid-cols-4 gap-6">
            {/* Secure & Reliable */}
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center text-blue-500 shrink-0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="3"
                    y="11"
                    width="18"
                    height="11"
                    rx="2"
                    ry="2"
                  ></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <span className="text-[14px] font-medium text-slate-600 leading-snug">
                Secure &<br />
                Reliable
              </span>
            </div>

            {/* Trusted by Thousands */}
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-green-50 flex items-center justify-center text-green-500 shrink-0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5c-2.2 0-4 1.8-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <span className="text-[14px] font-medium text-slate-600 leading-snug">
                Trusted by
                <br />
                Thousands
              </span>
            </div>

            {/* Simple & Efficient */}
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-purple-50 flex items-center justify-center text-purple-500 shrink-0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2v4"></path>
                  <path d="M12 18v4"></path>
                  <path d="M4.93 4.93l2.83 2.83"></path>
                  <path d="M16.24 16.24l2.83 2.83"></path>
                  <path d="M2 12h4"></path>
                  <path d="M18 12h4"></path>
                  <path d="M4.93 19.07l2.83-2.83"></path>
                  <path d="M16.24 7.76l2.83-2.83"></path>
                </svg>
              </div>
              <span className="text-[14px] font-medium text-slate-600 leading-snug">
                Simple &<br />
                Efficient
              </span>
            </div>

            {/* Focused on Your Financial Success */}
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-orange-50 flex items-center justify-center text-orange-400 shrink-0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
              </div>
              <span className="text-[14px] font-medium text-slate-600 leading-snug">
                Focused on Your
                <br />
                Financial Success
              </span>
            </div>
          </div>
        </div>

        {/* --- Build Your Financial Future Today (CTA) --- */}
        <div className="bg-[#f0f4ff] rounded-[2rem] p-8 shadow-[0_4px_20px_rgb(0,0,0,0.02)] border border-blue-100 flex items-center justify-between mb-8">
          <div className="flex items-center gap-6">
            <div className="w-14 h-14 bg-white rounded-[1rem] flex items-center justify-center text-[#1a4bdf] shadow-sm border border-blue-50">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <polyline points="9 12 11 14 15 10"></polyline>
              </svg>
            </div>
            <div>
              <h3 className="text-[18px] font-bold text-slate-900 mb-1">
                Build Your Financial Future Today
              </h3>
              <p className="text-[14px] text-slate-500 font-medium">
                Join thousands of Africans already growing their wealth with
                Empowering Africa.
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 bg-[#1a4bdf] hover:bg-blue-700 text-white px-8 py-3.5 rounded-full font-bold text-[15px] shadow-md shadow-blue-600/20 transition-all active:scale-95">
            Get Started
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutPlatform;
